export default __webpack_public_path__ + "static/media/tt.828de802.svg";